<template>
  <div class="index">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="跟进安排" name="first">
        <div class="index">
          <el-card class="index-container" shadow="never">
            <p class="index-container-title" style="padding: 0px">客户信息</p>
            <table border="" class="index-container-table">
              <tr>
                <td class="index-container-table-label">客户姓名</td>
                <td class="index-container-table-text">
                  {{ clientForm.userName }}
                </td>
                <td class="index-container-table-label">联系电话</td>
                <td class="index-container-table-text">
                  {{ clientForm.mobilePhone }}
                </td>
                <td class="index-container-table-label">详细地址</td>
                <td class="index-container-table-text">
                  {{ clientForm.address }}
                </td>
              </tr>
              <tr>
                <td class="index-container-table-label">客户备注</td>
                <td class="index-container-table-text" colspan="5">
                  {{ clientForm.userRemark }}
                </td>
              </tr>
            </table>
            <el-table
              :data="clientForm.children"
              :header-cell-style="{
                'text-align': 'center',
                background: '#edf3fe',
                color: '#0d6fb8',
              }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column
                label="会员姓名"
                prop="childName"
              ></el-table-column>
              <el-table-column label="孩子性别" prop="gender">
                <template slot-scope="{ row }">
                  <div>
                    {{ row.gender == 0 ? "男" : row.gender == 1 ? "女" : "未知" }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="出生年月"
                prop="birthday"
              ></el-table-column>
              <el-table-column label="乳名" prop="nickName"></el-table-column>
              <el-table-column label="渠道" prop="channel"></el-table-column>
              <el-table-column label="来源" prop="source"></el-table-column>
            </el-table>
          </el-card>
          <!-- <el-card class="index-container" shadow="never">
            <p class="index-container-title" style="padding: 0px">孩子信息</p>
            <el-table
              :data="clientForm.children"
              class="index-container-table"
              :header-cell-style="{
                'text-align': 'center',
                background: '#edf3fe',
                color: '#0d6fb8',
              }"
              :cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column
                label="会员姓名"
                prop="childName"
              ></el-table-column>
              <el-table-column label="孩子性别" prop="gender"></el-table-column>
              <el-table-column
                label="出生年月"
                prop="birthday"
              ></el-table-column>
              <el-table-column label="乳名" prop="nickName"></el-table-column>
              <el-table-column label="渠道" prop="channel"></el-table-column>
              <el-table-column label="来源" prop="source"></el-table-column>
            </el-table>
          </el-card> -->
          <el-card
            class="index-container"
            shadow="never"
            v-if="clientForm.followInfo && clientForm.followInfo.card"
          >
            <p class="index-container-title" style="padding: 0px">会员卡信息</p>
            <table border="" class="index-container-table">
              <tr>
                <td class="index-container-table-label">会员卡名称</td>
                <td class="index-container-table-text">
                  {{ clientForm.followInfo.card.cardName }}
                </td>
                <td class="index-container-table-label">会员卡种类</td>
                <td class="index-container-table-text">
                  {{ clientForm.followInfo.card.cardKind }}
                </td>
                <td class="index-container-table-label">总课时</td>
                <td class="index-container-table-text">
                  {{ clientForm.followInfo.card.totalCount }}
                </td>
              </tr>
              <tr>
                <td class="index-container-table-label">剩余课时</td>
                <td class="index-container-table-text">
                  {{ clientForm.followInfo.card.residueCount }}
                </td>
                <td class="index-container-table-label">有效期</td>
                <td class="index-container-table-text">
                  {{ clientForm.followInfo.card.expirationDate }}
                </td>
              </tr>
            </table>
          </el-card>
          <el-card class="index-container" shadow="never">
            <p class="index-container-title" style="padding: 0px">跟进信息</p>
            <div class="index-container-table" v-if="clientForm.followInfo">
              <el-form ref="registerRef" label-width="120px" :rules="rules">
                <el-row>
                  <el-col :span="24">
                    <el-form-item required="" label="更换理由">
                      <el-input
                        type="textarea"
                        autosize
                        v-model="clientForm.followInfo.followContent"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="当前阶段:">
                      <el-select
                        filterable=""
                        v-model="clientForm.followInfo.currentStage"
                        placeholder="请选择"
                      >
                        <el-option
                          v-for="item in currentStageList"
                          :key="item.v"
                          :label="item.des"
                          :value="item.v"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" v-if="currentBelong != 2">
                    <el-form-item label="意向级别:">
                      <el-select
                        filterable=""
                        placeholder="请选择"
                        v-model="clientForm.followInfo.intentionLevel"
                      >
                        <el-option
                          v-for="item in intentionLevelList"
                          :key="item.state"
                          :label="item.name"
                          :value="item.state"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <!-- <el-col :span="12">
                    <el-form-item label="跟进状态:">
                      <el-select filterable="" placeholder="请选择" v-model="clientForm.followInfo.followState">
                        <el-option
                          v-for="item in followStateList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col> -->
                  <el-col
                    v-for="(cur, curIx) in clientForm.followInfo.workers"
                    :key="curIx"
                  >
                    <el-form-item label="当前跟进人:">
                      <el-select
                        filterable=""
                        v-model="cur.workerId"
                        placeholder="请选择"
                        clearable=""
                      >
                        <el-option
                          v-for="item in workersList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          :disabled="
                            cur.workerId == item.id ||
                            clientForm.followInfo.workers
                              .map((mk) => {
                                return Number(mk.workerId);
                              })
                              .includes(item.id)
                              ? true
                              : false
                          "
                        >
                        </el-option>
                      </el-select>
                      <i
                        v-if="clientForm.followInfo.workers.length - 1 == curIx"
                        class="el-icon-circle-plus"
                        style="font-size: 20px; cursor: pointer"
                        @click="handleAddPerson"
                      ></i>
                      <i
                        v-if="clientForm.followInfo.workers.length > 1"
                        class="el-icon-remove"
                        style="
                          font-size: 20px;
                          cursor: pointer;
                          margin-left: 15px;
                        "
                        @click="handleDelPerson(curIx)"
                      ></i>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <!-- <el-col>
                    <el-form-item label="更换跟进人">
                      <el-transfer
                        v-model="targetWorkerList"
                        :data="workersList"
                        :props="{
                          key: 'id',
                          label: 'name',
                        }"
                      ></el-transfer>
                    </el-form-item>
                  </el-col> -->
                </el-row>
              </el-form>
            </div>
          </el-card>
        </div>
        <!-- <div class="dialog-footer-1">
          <el-button type="primary" @click="handleUpdate()">保存</el-button>
          <el-button @click="handleCancel">取消</el-button>
        </div> -->
      </el-tab-pane>
      <el-tab-pane label="跟进详情" name="second">
        <!-- <table border class="index-table">
          <tr>
            <td class="index-table-label">家长姓名</td>
            <td>张三达</td>
            <td class="index-table-label">手机号</td>
            <td>11111111111</td>
            <td class="index-table-label">会员姓名</td>
            <td>刘大大</td>
          </tr>
          <tr>
            <td class="index-table-label">孩子小名</td>
            <td>张三达</td>
            <td class="index-table-label">孩子性别</td>
            <td>男</td>
            <td class="index-table-label">生日</td>
            <td>2019-02-05</td>
          </tr>
        </table> -->
        <div class="index-steps" @scroll="checkScroll" ref="scrollContent">
          <el-steps direction="vertical">
            <el-step v-for="(info, ix) in recordList" :key="ix">
              <img
                class="index-steps-icon"
                slot="icon"
                :src="
                  ix == 0
                    ? require('@/assets/icons/xa.png')
                    : require('@/assets/icons/xb.png')
                "
                alt=""
              />
              <div slot="description">
                <p>
                  跟进时间：{{ info.recordDateTime }} 跟进人：{{
                    info.followWorkerName
                  }}
                </p>
                <p>{{ info.feedbackResult }}</p>
                <i
                  v-if="info.feedbackAudio"
                  style="font-size: 22px; color: #0e6fb8"
                  class="el-icon-microphone"
                  @click="clickAudio(info.feedbackAudio)"
                ></i>
              </div>
            </el-step>
          </el-steps>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      title="口令"
      :visible.sync="visibleCommand"
      width="500px"
      center
      append-to-body
    >
      <el-form ref="registerRefV" label-width="120px">
        <el-form-item label="输入口令:" prop="userPhone">
          <el-input
            style="width: 270px"
            placeholder=""
            readonly="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleCommand = false">取 消</el-button>
        <el-button type="primary" @click="onBtnhandleUpdate()">确 定</el-button>
      </span>
    </el-dialog>

    <template v-if="audioDialog">
      <el-dialog
        title="音频文件"
        width="500px"
        :visible.sync="audioDialog"
        center
        :modal="false"
      >
        <audioDialog ref="audioDialogRef" />
      </el-dialog>
    </template>
  </div>
</template>

<script>
import { adminFollowrecordList } from "@/api/PotentialCustomers";
import audioDialog from "@/components/audioDialog";

export default {
  components: {
    audioDialog,
  },
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    workersList: {
      type: Array,
      default: () => [],
    },
    masterId: {
      type: [Number, String],
      default: null,
    },
    currentBelong: {
      type: [Number, String],
      default: 1,
    },
  },
  data() {
    return {
      audioDialog: false,

      genderOptions: [
        {
          value: "0",
          label: "男",
        },
        {
          value: "1",
          label: "女",
        },
      ],
      activeName: "first",
      formData: {},
      visibleCommand: false,
      clientForm: this.clientInfo,
      intentionLevelList: [
        {
          state: 1,
          name: "A+",
        },
        {
          state: 2,
          name: "A",
        },
        {
          state: 3,
          name: "B+",
        },
        {
          state: 4,
          name: "B",
        },
        {
          state: 5,
          name: "C",
        },
        {
          state: 6,
          name: "D",
        },
      ],
      currentStageList: [],
      followStateList: [
        {
          state: 1,
          name: "短期跟进",
        },
        {
          state: 2,
          name: "长期跟进",
        },
      ],
      rules: {
        // followContent: [
        //   {
        //     required: true,
        //     message: "请输入跟进内容标题",
        //     trigger: ["change", "blur"],
        //   },
        // ],
      },
      logListPageNum: 1,
      logListPageSize: 10,
      logListPageTotalPage: 0,
      recordList: [],
    };
  },
  watch: {
    clientInfo: {
      handler(newVal, oldVal) {
        this.init()
        this.activeName = 'first'
        this.clientForm = newVal;
        if (!this.clientForm.followInfo) {
          this.clientForm.followInfo = {
            followContent: undefined,
            currentStage: null,
            intentionLevel: undefined,
            intentionLevel: undefined,
            workers: [
              {
                workers: null,
              },
            ],
          };
        } else {
          this.clientForm.followInfo = {
            ...this.clientForm.followInfo,
            workers:this.clientForm.followInfo.workers && this.clientForm.followInfo.workers.length ? this.clientForm.followInfo.workers : [
                {
                  workers: null,
                },
              ],
          }
        }
      },
    },
  },

  methods: {
    init() {
      switch (this.currentBelong) {
        case 2:
          this.currentStageList = [
            { v: 10, des: "首次跟进" },
            { v: 11, des: "跟进中" },
            { v: 12, des: "跟进结果" },
            { v: 13, des: "跟进完成" },
          ];
          break;
        default:
          this.currentStageList = [
            { v: 1, des: "建立联系" },
            { v: 2, des: "确认意向" },
            { v: 3, des: "承诺到访" },
            { v: 4, des: "预约试听" },
            { v: 5, des: "完成试听" },
            { v: 6, des: "完成缴费" },
            { v: 7, des: "放弃" },
            { v: 8, des: "重新跟进" },
          ];
      }
    },
    clickAudio(val) {
      console.log(val, "val");
      this.audioDialog = true;

      this.$nextTick(() => {
        this.$refs.audioDialogRef.audio = val;
      });
      console.log(val, this.$refs.audioDialogRef, "refs.audioDialogRef=======");
    },
    handleClick(tab, event) {
      this.$emit("cancle", this.activeName);
      if (this.activeName == "second") {
        if (this.masterId) {
          this.getFollowRecordAxios();
        }else{
          this.recordList = []
        }
      }
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    // 获取跟进记录详情
    async getFollowRecordAxios() {
      let params = {
        pageNum: this.logListPageNum,
        pageSize: this.logListPageSize,
        masterId: this.masterId,
      };
      const response = await adminFollowrecordList(params);
      if (response.code == 20000) {
        let data = response.data;
        this.recordList =
          this.logListPageNum == 1
            ? data.list
            : this.recordList.concat(data.list);
        this.logListPageTotalPage = data.totalPage;
      }
    },
    // 检查滚动并触发加载更多数据
    checkScroll() {
      const content = this.$refs.scrollContent;
      if (
        content.scrollHeight - content.clientHeight - content.scrollTop < 20 &&
        this.logListPageTotalPage > this.logListPageNum
      ) {
        this.logListPageNum++; // 增加页数
        this.getFollowRecordAxios();
      }
    },
    handleAddPerson() {
      let self = this;
      if (self.clientForm.followInfo.workers.length) {
        try {
          self.clientForm.followInfo.workers.forEach((item) => {
            if (!item.workerId) {
              self.$message.warning("请先选择当前跟进人");
              throw new Error("Something bad happened.");
            }
          });
        } catch (error) {
          if (error.message === "Something bad happened.") throw error;
        }
        self.clientForm.followInfo.workers.push({ workerId: "" });
      } else {
        self.clientForm.followInfo.workers.push({ workerId: "" });
      }
    },
    handleDelPerson(index) {
      this.$delete(this.clientForm.followInfo.workers, index);
    },
    handleUpdate() {
      // this.visibleCommand = true;
    },
    onBtnhandleUpdate() {
      this.visibleCommand = false;
      this.$emit("onBtnhandleUpdate");
    },
  },
};
</script>

<style lang="scss" scoped>
.index {
  // height: 600px;
  // overflow-x: scroll;
  &-container {
    background: #ffffff;
    border-radius: 8px;
    padding: 8px 25px 13px;
    margin-bottom: 15px;
    /deep/ .el-card__body {
      padding: 0px;
    }
    &-title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #282d30;
    }
    &-table {
      border-collapse: collapse;
      border-color: #ededed;
      margin-top: 10px;
      tr {
        td {
          padding: 11px 0;
        }
      }
      &-label {
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0e6fb8;
        background: #cedef5;
        width: 110px;
      }
      &-text {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #74798c;
        width: 250px;
        padding-left: 12px !important;

      }
    }
  }
  &-table {
    width: 100%;
    border-collapse: collapse;
    border-color: #e4e1e1;
    tr {
      td {
        text-align: center;
        padding-top: 10px;
        padding-bottom: 10px;
      }
    }
    &-label {
      background-color: #e9e1e1;
    }
  }
  &-steps {
    margin-top: 20px;
    /deep/ .el-step__description {
      color: #333333;
    }
    /deep/ .el-step__line {
      background: #b6b3b3;
    }
    &-icon {
      width: 25px;
      height: 25px;
    }
    /deep/ .el-step__icon.is-text {
      border: none;
    }
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background: #ffffff;
  }
}
/deep/ .el-dialog--center {
  border: 2px solid #d0d0d0;
  border-radius: 10px;
}
/deep/ .el-dialog__header {
  border-radius: 10px;
  background: #f0f7ff;
}
/deep/.el-table .el-table__cell{
  padding: 6px 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/marketing-manager/potential-customers/components/follow-up-arrangement.vue